import { useContacts, useContactsState } from "modules/app/contexts";
import React, { memo, useRef, useEffect } from "react";
import * as S from "../../styles";

const VideoType = ({ url }) => {
  const videoRef = useRef(null);
  const { setPrevMedia, setCurrentMedia } = useContacts();
  const { prevMedia, currentMedia } = useContactsState();

  const handlePlay = (e) => {
    const mediaType = e.target.tagName;
    const id = e.target.currentSrc.replace("blob:", "");
    setPrevMedia(currentMedia);
    setCurrentMedia({ type: mediaType, id: id });
  };

  useEffect(() => {
    if (
      videoRef &&
      videoRef.current &&
      prevMedia.id !== currentMedia.id &&
      prevMedia.type === "VIDEO"
    ) {
      videoRef.current.pause();
    }
  }, [currentMedia]);

  return (
    <>
      {url ? (
        <S.Video controls ref={videoRef} onPlay={(e) => handlePlay(e)}>
          <source src={url} type="video/mp4" />
        </S.Video>
      ) : (
        <S.MessageLoading />
      )}
    </>
  );
};

export default memo(VideoType);
